import { Link, useNavigate, useLocation } from "react-router-dom";
import { navItems } from "../../mockData/navItems";
import { FooterStyle } from "./Footer.style";
import { FacebookIcon, InstagramIcon, LinkedinIcon } from "../../assets";

const quickLinks = [
  ...navItems,
  {
    name: "Get a Quote",
    link: "/",
  },
  {
    name: "Privacy Policy",
    link: "/privacy-policy",
  },
  {
    name: "Terms & Conditions",
    link: "/terms-conditions",
  },
  {
    name: "Disclaimer",
    link: "/disclaimer",
  },
];

const socialLinks = [
  {
    icon: <FacebookIcon />,
  },
  {
    icon: <InstagramIcon />,
  },
  {
    icon: <LinkedinIcon />,
  },
];

const trustBadges = [
  "FMCSA Registered",
  "Nationwide Transport",
  "Professional Support",
  "Fast Quote Response",
];

const Footer = () => {
  const currentYear = new Date().getFullYear();
  const navigate = useNavigate();
  const location = useLocation();

  const handleGetQuoteClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    
    const scrollToQuote = () => {
      // Use a small delay to ensure DOM is ready
      setTimeout(() => {
        const quoteSection = document.getElementById("quote-section");
        if (quoteSection) {
          const offsetTop = quoteSection.offsetTop;
          window.scrollTo({
            top: offsetTop,
            behavior: "smooth",
          });
        }
      }, 50);
    };
    
    // If already on home page, scroll to quote section
    if (location.pathname === "/") {
      scrollToQuote();
    } else {
      // Navigate to home and then scroll
      navigate("/");
      // Scroll after navigation completes
      setTimeout(() => {
        scrollToQuote();
      }, 300);
    }
  };

  return (
    <FooterStyle>
      <article className="footer-wrapper">
        <article className="trust-badges">
          {trustBadges.map((badge, index) => (
            <span key={index}>{badge}</span>
          ))}
        </article>

        <article className="footer-grid">
          <article className="footer-column brand-column">
            <p className="footer-description">
              "Super Hauling Inc provides reliable, professional, and
              secure vehicle transportation services across the United States
              with trusted support, FMCSA compliance, and safe nationwide
              delivery."
            </p>

            <article className="footer-social-links">
              {socialLinks.map((data, index) => {
                const { icon } = data;

                return (
                  <button type="button" disabled aria-label="Social media link unavailable" key={index}>
                    {icon}
                  </button>
                );
              })}
            </article>
          </article>

          <article className="footer-column">
            <h3>Quick Links</h3>

            <article className="footer-links-list">
              {quickLinks.map((data, index) => {
                const { name, link } = data;

                // Special handling for "Get a Quote" button
                if (name === "Get a Quote") {
                  return (
                    <a href="#quote-section" key={index} onClick={handleGetQuoteClick}>
                      {name}
                    </a>
                  );
                }

                return (
                  <Link to={link} key={index}>
                    {name}
                  </Link>
                );
              })}
            </article>
          </article>

          <article className="footer-column">
            <h3>Contact</h3>

            <article className="footer-contact-list">
              <p>
                Super Hauling Inc
                <br />
                500 Rawhide Ln
                <br />
                Florence, TX 76527
              </p>

              <a href="mailto:info@superspeedhauling.us">
                info@superspeedhauling.us
              </a>

              <a href="tel:+18886939563">(888) 693-9563</a>

              <p>
                <strong>USDOT:</strong> 9016315
              </p>

              <p>
                <strong>MC:</strong> 57541812
                <br />
                <small>DBA Super Speed Hauling</small>
              </p>

              <a href="#quote-section" className="quote-btn" onClick={handleGetQuoteClick}>
                Get Free Quote
              </a>
            </article>
          </article>

          <article className="footer-column">
            <h3>Legal</h3>

            <article className="legal-card">
              <img
                src="/images/fmcsa-logo.png"
                alt="FMCSA"
                className="fmcsa-logo"
              />

              <p>
                <strong>USDOT:</strong> 9016315
              </p>

              <p>
                <strong>MC:</strong> 57541812
              </p>

              <p>
                <strong>Super Hauling Inc</strong>
                <br />
                <small>DBA Super Speed Hauling</small>
              </p>

              <p>
                SMS consent and mobile opt-in information are never shared for
                marketing or promotional purposes.
              </p>

              <a
                href="https://safer.fmcsa.dot.gov/CompanySnapshot.aspx"
                target="_blank"
                rel="noreferrer"
                className="dot-btn"
              >
                Verify FMCSA Registration
              </a>
            </article>
          </article>
        </article>
      </article>

      <article className="copy-right">
        <div className="copy-right-inner">
          <p>
            Copyright © {currentYear} Super Hauling Inc. All rights
            reserved.
          </p>

          <article className="bottom-links">
            <Link to="/terms-conditions">Terms & Conditions</Link>
            <Link to="/privacy-policy">Privacy Policy</Link>
            <Link to="/disclaimer">Disclaimer</Link>
          </article>
        </div>
      </article>
    </FooterStyle>
  );
};

export default Footer;

